/**
 * Get a DOM element from given path (list of ancestors indexes).
 * @param {*} path An array of ancestors indexes, from top to bottom.
 * @returns A DOM element if found, null otherwise.
 */
const getElementFromPath = (path) => {
  let element = document.getElementById('app')

  for (const nodeIndex of path) {
    const child = element.children.item(nodeIndex)
    element = child

    if (element === null) {
      break
    }
  }

  return element
}

/**
 * Restore the scroll position. To do so, re-apply heights for all v-lazy components to maintain position consistency when
 * some v-lazy components are not loaded yet.
 * @param {*} nodeToRestore The navigation node to restore.
 */
const restoreScrollPosition = (nodeToRestore) => {
  const lazyNodes = Array.from(document.getElementsByClassName('v-lazy'))
  const storedLazyHeights = nodeToRestore.state.lazyHeights
  const storedScrollPosition = nodeToRestore.state.scrollPosition

  if (storedLazyHeights.length === lazyNodes.length) {
    lazyNodes.forEach((lazyNode, index) => {
      lazyNode.style.minHeight = `${storedLazyHeights[index]}px`
    })
  }

  window.scrollTo(storedScrollPosition.x, storedScrollPosition.y)
}

/**
 * Restores focus on proper DOM element.
 * @param {*} nodeToRestore The navigation node to restore.
 */
const restoreFocus = (storedFocus) => {
  if (storedFocus.id !== '') {
    const elementToFocus = document.getElementById(storedFocus.id)
    if (elementToFocus) {
      elementToFocus.focus()
    }
  } else {
    let focusRetryMaxAttempts = 5
    const focusRetryInterval = setInterval(() => {
      const elementToFocus = getElementFromPath(storedFocus.path)

      if (elementToFocus) {
        elementToFocus.focus()
        clearInterval(focusRetryInterval)
      } else {
        focusRetryMaxAttempts--
        if (focusRetryMaxAttempts <= 0) {
          clearInterval(focusRetryInterval)
        }
      }
    }, 300)
  }
}

/**
 *
 * @param {*} $store
 * @returns
 */
const restorePageState = ($store) => {
  const nodeToRestore = $store.getters['navik/getNodeToRestore']

  if (!nodeToRestore) {
    return
  }

  // Note: normally, scroll position is restored with the scrollBehavior function in router,
  // but with lazy loading components, we have to call this custom function to handle this situation.
  if (nodeToRestore.state.lazyHeights.length > 0) {
    restoreScrollPosition(nodeToRestore)
  }

  restoreFocus(nodeToRestore.state.focus)
}

module.exports = restorePageState
